import React from 'react';
import { useIntl } from 'components/i18n';
import Tag from '@atlaskit/tag';
import { recurringSaleStatus } from "../messages";

const RecurringSaleStatus = ({isActive}: {isActive?: boolean} )=> {
  const intl = useIntl();

  return <Tag text={intl.formatMessage(recurringSaleStatus[isActive? 'active': 'inactive'])} isRemovable={false}/>
};

export default  RecurringSaleStatus;
